export const h = {
    "common": {
        "webSuffix": "- QIDI Tech QIDI Tech",
        "email": "صندوق البريد",
        "password": "كلمة السر",
        "verificationCode": "رمز التحقق",
        "username": "اسم المستخدم",
        "readAndAgree": "أوافق",
        "and": "و .",
        "userAgreement": "بروتوكول المستخدم",
        "privacyPolicy": "سياسة الخصوصية",
        "copy": "جميع الحقوق محفوظة ©  لعب دي الاحتفاظ بحق الملكية 2025",
        "sendVerificationCode": "إرسال رمز التحقق",
        "Sending": "إرسال",
        "tryAgainInSeconds": "حاول ثانية",
        "userNameRequired": "الرجاء إدخال اسم المستخدم",
        "passwordInputLabel": "الرجاء إدخال كلمة السر",
        "checkPasswordInputLabel": "الرجاء إدخال كلمة السر تأكيد",
        "userEmailRequired": "الرجاء إدخال عنوان البريد الإلكتروني",
        "userEmailInvalid": "الرجاء إدخال عنوان البريد الإلكتروني الصحيح",
        "emailCodeRequired": "الرجاء إدخال رمز التحقق",
        "newPasswordInputLabel": "الرجاء إدخال كلمة المرور الجديدة",
        "confirmPasswordInputLabel": "الرجاء إدخال كلمة المرور مرة أخرى",
        "passwordMismatchErrorLabel": "اثنين من المدخلات كلمة السر غير متناسقة",
        "agreementRequired": "يرجى قراءة والموافقة على الاتفاق",
        "tip": "جديلة",
        "tipAlreadyLogin": "تم الكشف عن تسجيل الدخول الخاص بك كما يمكنك الانتقال إلى مركز المستخدم",
        "tipWelcomeBack": "مرحبا بعودتك",
        "tipDeleteAccountFail": "حذف الحساب فشل ، حذف حساب واجهة مغلقة مؤقتا",
        "pleaseAgreeFirst": "يرجى الموافقة أولا",
        "agree": "موافقة",
        "refuse": "رفض",
        "tipNeedLogin": "يرجى تسجيل الدخول أولا",
        "tipChangePasswordSuccess": "تغيير كلمة المرور بنجاح ، والقفز إلى صفحة تسجيل الدخول بالنسبة لك",
        "tipGetUserInfoSuccess": "الحصول على المعلومات بنجاح",
        "tipGetUserInfoFail": "فشل في الحصول على المعلومات",
        "tipLoginOut": "خروج الدخول",
        "delete": "حذف .",
        "back": "رد : .",
        "init": "التهيئة",

        "passwordInputLengthErrorLabel": "كلمة السر يجب أن تكون بين 6 و 20",
        "changePasswordFail": "كلمة السر الأصلية خطأ",
        "tipDeleteAccountSuccess": "حذف الحساب بنجاح",
        "emailCodeSentSuccess": "تم إصدار رمز التحقق",
        "emailCodeSentFail": "رمز التحقق من الفشل",
        "emailLoginFail": "رمز التحقق قد انتهت",
        "passwordLoginFail": "كلمة السر خطأ",
        "editUserInfoSuccess": "تعديل معلومات المستخدم بنجاح",
        "registerSuccess": "النجاح في التسجيل",
        "registerFail": "فشل التسجيل",
        "registerEmailExistFail": "صندوق البريد موجود بالفعل",

        "resMessageTip0": "معلومات غير معروفة",
        "resMessageTip1": "كلمة السر خطأ",
        "resMessageTip2": "كلمة السر يجب أن تكون بين 6 و 20",
        "resMessageTip3": "خطأ في الحساب",
        "resMessageTip4": "تم إصدار رمز التحقق",
        "resMessageTip5": "رمز التحقق من الفشل",
        "resMessageTip6": "رمز التحقق قد انتهت",
        "resMessageTip7": "كلمة السر خطأ",
        "resMessageTip8": "كلمة السر لا يمكن أن يكون نفس كلمة السر القديمة",
        "resMessageTip9": "صندوق البريد موجود بالفعل",
        "resMessageTip10": "النجاح في التسجيل",
        "resMessageTip11": "فشل التسجيل",
        "resMessageTip12": "تعديل معلومات المستخدم بنجاح",
        "resMessageTip13": "فشل تعديل معلومات المستخدم",
        "resMessageTip14": "الحصول على النجاح",
        "resMessageTip15": "الحصول على فشل",
        "resMessageTip16": "تعديل كلمة السر بنجاح",
        "resMessageTip17": "فشل تعديل كلمة المرور",
        "resMessageTip18": "إعادة تعيين كلمة المرور بنجاح",
        "resMessageTip19": "فشل إعادة تعيين كلمة المرور",
        "resMessageTip20": "تسجيل الدخول بنجاح",
        "resMessageTip21": "فشل تسجيل الدخول",
        "resMessageTip22": "حذف الحساب بنجاح",
        "resMessageTip23": "فشل حذف الحساب",
        "resMessageTip24": "رمز الخطأ",
        "noUserInfoError": "خطأ في الشبكة ، يرجى تسجيل الدخول مرة أخرى"
    },
    "changePassword": {
        "newPassword": "كلمة السر الجديدة"
    },
    "deleteUser": {
        "tipDeleteUser": "أنا آسف أن كنت ترك . مرة واحدة يتم حذف الحساب الخاص بك ، جميع البيانات الشخصية الخاصة بك سوف تختفي بشكل دائم و لا يمكن استردادها .",
        "accountDeletionTerms": "حذف شرط"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "استرجاع كلمة السر عن طريق البريد",
        "confirmPassword": "تأكيد كلمة المرور",
        "resettingPassword": "إعادة تعيين كلمة المرور",
        "resetting": "إعادة"
    },
    "login": {
        "passwordLogin": "كلمة السر تسجيل الدخول",
        "verifyLogin": "التحقق من تسجيل الدخول",
        "accountRegistration": "تسجيل الحساب",
        "forgotPassword": "نسيت كلمة السر",
        "login": "سجل",
        "localLogin": "تسجيل الدخول المحلي",
        "loginOut": "تسجيل الخروج",
        "continueOnYourWay": "استمر في الذهاب"
    },
    "register": {
        "registerAnAccount": "رقم التسجيل",
        "register": "التسجيل"
    },
    "userCenter": {
        "personalInformation": "البيانات الشخصية",
        "modifyInformation": "تعديل المعلومات",
        "changePassword": "تعديل كلمة المرور",
        "cancelAccount": "تسجيل الخروج",
        "exitAccount": "خروج الحساب",
        "change": "عدل",
        "maxCharLimitTip": "اسم المستخدم لا يمكن أن يكون أكثر من 10 الأحرف الصينية"
    },
    "policies": {
        "deleteAccountPrivacy": "حذف حساب البروتوكول",
        "agreement": "استخدام بروتوكول",
        "privacyPolicy": "سياسة الخصوصية"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "Asia": "آسيا",
        "regionalSelection": "اختر بلدك أو المنطقة",
        "recommendedVisits": "أوصى الوصول",
        "NorthAmerica": "أمريكا الشمالية",
        "Europe": "أوروبا .",
        "Other": "أخرى .",
    }
}
export const aAndL ={
    "ar": {
        "Country": "عرب .",
        "Language": "بالعربية"
    },
    "cs": {
        "Country": "جمهورية التشيك",
        "Language": "اللغة التشيكية"
    },
    "de": {
        "Country": "ألمانيا",
        "Language": "ألماني"
    },
    "en": {
        "Country": "المملكة المتحدة",
        "Language": "إنجليزي"
    },
    "es": {
        "Country": "أسبانيا",
        "Language": "إسبانية"
    },
    "fr": {
        "Country": "فرنسا .",
        "Language": "الفرنسية ."
    },
    "he": {
        "Country": "إسرائيل .",
        "Language": "العبرية"
    },
    "hu": {
        "Country": "هنغاريا",
        "Language": "اللغة الهنغارية"
    },
    "it": {
        "Country": "إيطاليا .",
        "Language": "الايطالية"
    },
    "ja": {
        "Country": "اليابان .",
        "Language": "اليابانية ."
    },
    "ko": {
        "Country": "جمهورية كوريا",
        "Language": "كوري"
    },
    "nl": {
        "Country": "هولندا .",
        "Language": "الهولندية"
    },
    "pt": {
        "Country": "البرتغال",
        "Language": "البرتغالية"
    },
    "pt_BR": {
        "Country": "البرتغال ( البرازيل )",
        "Language": "البرتغالية ( البرازيل )"
    },
    "ru": {
        "Country": "روسيا .",
        "Language": "روسي"
    },
    "sv": {
        "Country": "سويسرا",
        "Language": "السويدية"
    },
    "tr": {
        "Country": "تركيا .",
        "Language": "اللغة التركية"
    },
    "uk": {
        "Country": "أوكرانيا .",
        "Language": "اللغة الأوكرانية"
    },
    "zh": {
        "Country": "البر الرئيسى للصين",
        "Language": "الصينية المبسطة"
    },
    "zh_tw": {
        "Country": "الصين تايوان",
        "Language": "الصينية التقليدية"
    },
    "Canada": {
        "Country": "كندا .",
        "Language": "إنجليزي"
    },
    "United_States": {
        "Country": "و { غ",
        "Language": "إنجليزي"
    },
    "United_Kingdom": {
        "Country": "المملكة المتحدة",
        "Language": "إنجليزي"
    },
    "EU_Countries": {
        "Country": "دول الاتحاد الأوروبي",
        "Language": "إنجليزي"
    },
    "Australia": {
        "Country": "أستراليا .",
        "Language": "إنجليزي"
    },
    "globalzh": {
        "Country": "العالمية",
        "Language": "الصينية المبسطة"
    },
    "globalen": {
        "Country": "Global",
        "Language": "إنجليزي"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/ar.js